/* TextColorMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./TextColorMenuItem.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { textColorMessages as messages } from '@atlaskit/editor-common/messages';
import { getInputMethodFromParentKeys, useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { textPaletteTooltipMessages } from '@atlaskit/editor-common/ui-color';
import { hexToEditorTextPaletteColor } from '@atlaskit/editor-palette';
import { ColorPalette, useToolbarDropdownMenu } from '@atlaskit/editor-toolbar';
import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
var styles = {
  container: "_zulp12x7"
};
export function TextColorMenuItem(_ref) {
  var api = _ref.api,
    parents = _ref.parents;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['textColor'], function (states) {
      var _states$textColorStat, _states$textColorStat2, _states$textColorStat3;
      return {
        color: (_states$textColorStat = states.textColorState) === null || _states$textColorStat === void 0 ? void 0 : _states$textColorStat.color,
        defaultColor: ((_states$textColorStat2 = states.textColorState) === null || _states$textColorStat2 === void 0 ? void 0 : _states$textColorStat2.defaultColor) || null,
        palette: ((_states$textColorStat3 = states.textColorState) === null || _states$textColorStat3 === void 0 ? void 0 : _states$textColorStat3.palette) || []
      };
    }),
    color = _useSharedPluginState.color,
    defaultColor = _useSharedPluginState.defaultColor,
    palette = _useSharedPluginState.palette;
  var _useEditorToolbar = useEditorToolbar(),
    editorView = _useEditorToolbar.editorView;
  // Warning! Do not destructure editorView, it will become stale
  var _ref2 = editorView !== null && editorView !== void 0 ? editorView : {
      state: null,
      dispatch: null
    },
    state = _ref2.state,
    dispatch = _ref2.dispatch;
  var context = useToolbarDropdownMenu();
  var closeMenu = context === null || context === void 0 ? void 0 : context.closeMenu;
  var handleTextColorChange = useCallback(function (color) {
    if (expValEquals('platform_editor_toolbar_aifc_fix_editor_view', 'isEnabled', true)) {
      var _api$textColor;
      if (!(editorView !== null && editorView !== void 0 && editorView.state) || !(editorView !== null && editorView !== void 0 && editorView.dispatch)) {
        return;
      }
      if (api !== null && api !== void 0 && (_api$textColor = api.textColor) !== null && _api$textColor !== void 0 && (_api$textColor = _api$textColor.actions) !== null && _api$textColor !== void 0 && _api$textColor.changeColor) {
        api.textColor.actions.changeColor(color, getInputMethodFromParentKeys(parents))(editorView.state, editorView.dispatch);
        closeMenu === null || closeMenu === void 0 || closeMenu();
      }
    } else {
      var _api$textColor2;
      if (!state || !dispatch) {
        return;
      }
      if (api !== null && api !== void 0 && (_api$textColor2 = api.textColor) !== null && _api$textColor2 !== void 0 && (_api$textColor2 = _api$textColor2.actions) !== null && _api$textColor2 !== void 0 && _api$textColor2.changeColor) {
        api.textColor.actions.changeColor(color, getInputMethodFromParentKeys(parents))(state, dispatch);
        closeMenu === null || closeMenu === void 0 || closeMenu();
      }
    }
  }, [editorView === null || editorView === void 0 ? void 0 : editorView.state, editorView === null || editorView === void 0 ? void 0 : editorView.dispatch, api === null || api === void 0 ? void 0 : api.textColor.actions, parents, closeMenu, state, dispatch]);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Stack, {
    xcss: styles.container,
    testId: "text-color-menu-item"
  }, expValEquals('platform_editor_toolbar_aifc_patch_2', 'isEnabled', true) ? /*#__PURE__*/React.createElement(Heading, {
    size: "xxsmall"
  }, formatMessage(messages.textColorTooltip)) : /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, formatMessage(messages.textColorTooltip)), /*#__PURE__*/React.createElement(ColorPalette, {
    onClick: function onClick(color) {
      handleTextColorChange(color);
    },
    selectedColor: color || defaultColor,
    paletteOptions: {
      palette: palette,
      hexToPaletteColor: hexToEditorTextPaletteColor,
      paletteColorTooltipMessages: textPaletteTooltipMessages
    }
  }));
}